import { Component, Input } from '@angular/core';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { MatLegacyTableModule as MatTableModule } from '@angular/material/legacy-table';
import { NgIf } from '@angular/common';

@Component({
  selector: 'app-table-skeleton',
  templateUrl: './table-skeleton.component.html',
  styleUrls: ['./table-skeleton.component.css'],
  standalone: true,
  imports: [NgIf, MatTableModule, NgxSkeletonLoaderModule]
})
export class TableSkeletonComponent {
  @Input() tableType: string = '';

  displayedColumns: string[] = ['$implicit', 'index', 'count', 'first', 'last', 'even', 'odd'];
  data: string[] = ['one', 'two', 'three', 'four', 'five', 'six', 'seven', 'eigth', 'nine', 'ten'];

  displayedColumnsSmall: string[] = ['$implicit', 'index', 'count', 'first', 'last', 'even', 'odd'];
  dataSmall: string[] = ['one', 'two', 'three', 'four', 'five'];

  dataExtraSmall: string[] = ['one', 'two', 'three', 'four'];

  displayedColumnsListSo: string[] = ['$implicit', 'another', 'index', 'count', 'first', 'last', 'even', 'odd'];
  dataListSo: string[] = ['one', 'another', 'two', 'three', 'four', 'five', 'five'];

  constructor() {}
}
